export enum DateType {
  WorkDay = 1,
  Weekend = 2,
  DayOff = 3,
}

export type SpecificDays = {
  day: string;
  type: DateType;
};
